import React, { Component } from 'react';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import LoginWindow from './AcComponents/LoginWindow.js';
import CompletaRegistrazione from './AcComponents/CompletaRegistrazione.js';
import PrimoAccesso from './AcComponents/PrimoAccesso.js';

import './App.css';

import { Session } from './AcComponents/classi/Session.js';
import { Config } from './AcComponents/Config.js';

const sessione = new Session();
const config = new Config();

class App extends Component {
    
    constructor(){
        super();
        this.state = {}

        if( sessione.get('id_cliente') === null )
        {
            // pulisci la sessione prima di partire
            sessione.clear();
            sessione.set('datainfosocieta' , null );        
        }
        
        this.caricaInfoSocieta = this.caricaInfoSocieta.bind(this);        

        this.impostaCssDefault();
        this.caricaInfoSocieta();
    }

  
    impostaCssDefault()
    {
        // palette di default windows
        // https://developer.microsoft.com/en-us/fabric#/styles/colors#palettes

        var palette = config.getPaletteBase();
        
        for(var key in palette)
        {
            // ESEMPIO : document.body.style.setProperty('--themeDarker', '#004578');
            document.body.style.setProperty('--'+key, palette[key]);
            document.body.style.setProperty(key, palette[key]);
        }
    }
  

   
    componentDidMount() {
        document.title = "Area Clienti "+config.getVersion()+" (" + config.getEnv()+')';
        var viewport = document.querySelector("meta[name=viewport]");
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
    }

    caricaInfoSocieta(){

        // passo id_clinete a null per recuperare i dati della società
        let request = new Request( config.get("customers_configurazioni"),{
            method: 'POST', mode: 'cors', credentials: "include", 
            body: JSON.stringify({ id_cliente: null })
        });

        fetch(request)
        .then(function(response){
            return response.json();
        }).then(function(result){
            if (result.success) {

                sessione.set('datainfosocieta' , result.data );

                if( 'colori' in result.data )
                {
                    for (var key in result.data.colori ) {
                        // document.body.style.setProperty('--themeDarker', '#004578');
                        document.body.style.setProperty( key , result.data.colori[key]);
                    }
                }

                sessione.set('imglogosocieta', "");
                if( 'logo' in result.data )
                {
                    if( result.data.logo !== '' )
                    {
                        var pos = result.data.logo.indexOf("http");
                        let logo = '';

                        if( pos === -1) { logo = config.getLocation() + result.data.logo; }
                        else { logo = result.data.logo; }

                        document.body.style.setProperty( "--logoSocieta" , "url('"+logo+"')");
                        sessione.set('imglogosocieta', logo);
                    }
                }

                document.body.style.setProperty( "--logoSocietaParams" , "150px auto");
                
                // qui devo cambiare il favicon pescando da una fonte esterna caricata da Gestione Area Clienti
                
                if( 'favicon' in result.data )
                {
                    if( result.data.favicon !== '' )
                    {
                        var link = document.querySelector("link[rel~='icon']");
                        if (!link) {
                            link = document.createElement('link');
                            link.rel = 'icon';
                            document.head.appendChild(link);
                        }
                        link.href = result.data.favicon;
                    }
                }
                
            } 
        });
    }
  
    render() {
        if( true === config.isRegistraLink() ){
            return  <Fabric><PrimoAccesso /></Fabric>;
        } else if( true === config.isAuthLink() ){
            return  <Fabric><CompletaRegistrazione /></Fabric>;
        }else{
            return  <Fabric><LoginWindow /></Fabric>;
        }
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js